import React, { memo, useCallback } from 'react';
import { CloseIcon } from '@yme/assets/icons';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { ClearSelectedStyled, FilterClearMiniButtonStyled } from './styled';
export const FilterClearAll = memo(({ onClickHandler, isRightToLeft, clearLabel }) => {
    // md: edge case: onClickHandler should be wrapped into setTimeout
    // because of incorrect behavior in conjunction with useOutsideClick hook,
    // clearAll node destroyed before hook condition check
    const handleClick = useCallback(() => {
        setTimeout(onClickHandler, 0);
    }, [onClickHandler]);
    return (React.createElement(ClearSelectedStyled, null,
        React.createElement(FilterClearMiniButtonStyled, { iconType: CloseIcon, onClick: handleClick, isRightToLeft: isRightToLeft, contentColor: colorCoreBlack300, isFirstIcon: true }, clearLabel)));
});
FilterClearAll.displayName = 'FilterClearAll';
